import { restrictedProp } from 'airbnb-prop-types';
export const deprecated = (removalVersion) => restrictedProp((_, propName, componentName, location) => `"${propName}" ${location} on "${componentName}" has been deprecated and will be removed in ${removalVersion}.`);
//# sourceMappingURL=deprecated.js.map